// extracted by mini-css-extract-plugin
export var NewsItemImages = "NewsItemImages-module--NewsItemImages--ZM0RY";
export var images = "NewsItemImages-module--images--3XtFA";
export var news = "NewsItemImages-module--news--sTYY0";